let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f1B4n")).then(() => parcelRequire('03O98'));